import {useAuth} from 'app/modules/auth'
import LecturerDashboard from './LecturerDashboard'
import StudentDashboard from './StudentDashboard'
import AdminDashboard from './AdminDashboard'
import ParentDashboard from './ParentDashboard'

const DashboardWrapper = () => {
  const {currentUser} = useAuth()

  const firstRole = currentUser?.roles?.[0] || null

  if (firstRole === 'Lecturer') return <LecturerDashboard />
  else if (firstRole === 'Student') return <StudentDashboard />
  else if (currentUser?.position === 'Parent') return <ParentDashboard />
  else return <AdminDashboard />
}

export {DashboardWrapper}
